import {AppointmentTypeApiDto} from "../../api/model/rest";

export default class AppointmentType {

	constructor(public readonly id: string,
		public readonly name: string) {}

	static fromJson(json: AppointmentTypeApiDto): AppointmentType {
		return new AppointmentType(json.id, json.name);
	}

	getDisplayName(): string {
		return this.name.replace("_", " ");
	}
}

export enum AppointmentTypeEnum {
	Survey = "SURVEY",
	Quote = "QUOTE",
	Other = "OTHER"
}